import React from "react";
import "./CardPagination.scss";

const CardPagination = ({
  currentPage = 1,
  totalPages = 1,
  totalCount = 0,
  limit = 9,
  onPageChange,
}) => {

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage > 3) {
        pages.push("...");
      }

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };

  const pages = generatePageNumbers();

  return (
    <div className="card-pagination-wrapper">
      <div className="card-pagination-info">
        Showing{" "}
        <strong>
          {(currentPage - 1) * limit + 1}-
          {Math.min(currentPage * limit, totalCount)}
        </strong>{" "}
        of <strong>{totalCount}</strong> records
      </div>

    {totalPages > 1 && (
      <div className="card-pagination-controls">
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>

        {pages.map((page, index) =>
          page === "..." ? (
            <span key={index} className="dots">
              ...
            </span>
          ) : (
            <button
              key={index}
              className={page === currentPage ? "active" : ""}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    )}
    </div>
  );
};

export default CardPagination;
